module.exports = __webpack_public_path__ + "static/media/icon-module-quality-panel-desktop.4172b13a.svg";